module.exports = __webpack_public_path__ + "img/RORBPJR40008.8cd10570.png";